<script setup lang="ts">
import { ref } from 'vue';
import { createRouter, createWebHistory } from 'vue-router'
import Auth from '@/components/Auth.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import Prelevements from '@/pages/Prelevements.vue';
import Recoltes from '@/pages/Recoltes.vue';
import Cultures from '@/pages/Cultures.vue';
import Pilotage from '@/pages/Pilotage.vue';
import History from '@/pages/History.vue';
import PBRs from '@/pages/PBRs.vue';
import SettingsModal from '@/components/SettingsModal.vue';
import Footer from '@/components/Footer.vue';


// État du modal
const isSettingsModalOpen = ref(false);

// Fonction pour ouvrir le modal
const openSettingsModal = () => {
  isSettingsModalOpen.value = true;
};

// Fonction pour fermer le modal
const closeSettingsModal = () => {
  isSettingsModalOpen.value = false;
};

// Définir les routes
const routes = [
  { path: '/prelevement', component: Prelevements },
  { path: '/recoltes', component: Recoltes },
  { path: '/cultures', component: Cultures },
  { path: '/control', component: Pilotage },
  { path: '/history', component: History },
  { path: '/pbrs', component: PBRs }
]

// Créer le router
const router = createRouter({
  history: createWebHistory(),
  routes
})

// Exposer le router au template
defineExpose({
  router
})

</script>

<template>
  <div>
    <header class="header">
      <div class="left-section">
        <div class="logo-container">
          <img src="./assets/logo.png" alt="Logo" class="logo" />
          <h1 class="title">Référentiel RNCP37827</h1>
        </div>
        <ul class="nav-links">
          <li>
            <LanguageSwitcher />
          </li>
          <li>
            <button class="custom-btn settings-btn" @click="openSettingsModal">
              ⚙️
            </button>
          </li>
          <li><router-link to="/" class="nav-link">{{ $t('home') }}</router-link></li>
          <li><router-link to="/strains" class="nav-link">{{ $t('algae_library') }}</router-link></li>
          <li><router-link to="/cultures" class="nav-link">{{ $t('cultures') }}</router-link></li>
          <li><router-link to="/pbrs" class="nav-link">PBRs</router-link></li>
          <li><router-link to="/prelevement" class="nav-link">{{ $t('samples') }}</router-link></li>
          <li><router-link to="/recoltes" class="nav-link">{{ $t('harvests') }}</router-link></li>
          <li><router-link to="/control" class="nav-link">{{ $t('control') }}</router-link></li>
          <li><router-link to="/history" class="nav-link">{{ $t('history') }}</router-link></li>
        </ul>
      </div>

      <Auth />
    </header>

    <!-- Affichage du contenu des routes -->
    <router-view></router-view>

    <!-- Modal de réglages -->
    <SettingsModal :isOpen="isSettingsModalOpen" @close="closeSettingsModal" />

    <!-- Footer global -->
    <Footer />
  </div>
</template>

<style scoped>
/* Header layout */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  color: var(--color-fg);
}

/* Logo */
.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  width: 500px;
}

.logo {
  height: 120px;
  margin-bottom: 80px;
  z-index: 0;
}

.title {
  color: #000091;
  position: absolute;
  top: 95px;
  left: 163px;
  margin: 0;
  text-align: left;
  z-index: 1;
  font-size: 1.5em;
}

.settings-btn {
  padding: 0;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 4px;
  background: none;
  border: none;
  color: white;
}

/* Navigation links */
.nav-links {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 25px;
}

.nav-link {
  text-decoration: none;
  color: var(--color-accent);
  font-size: 16px;
  transition: color 0.3s;
}

.nav-link:hover {
  color: var(--color-success);
}

/* Mobile adjustments */
@media (max-width: 768px) {

  .header {
    flex-direction: column;
    /* Stack elements vertically */
    align-items: center;
    /* Center all content */
    padding: 10px;
    /* Reduce padding for mobile */
  }

  .left-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Center logo and nav links */
    width: 100%;
    /* Ensure full width */
  }

  .logo {
    height: 100px;
    /* Smaller logo size for mobile */
    margin-bottom: 30px;
    /* Adjust spacing */
  }

  .title {
    top: 80px;
    left: 175px;
    margin: 0;
    text-align: left;
    font-size: 1.2em;
    z-index: 1;
  }

  .nav-links {
    flex-direction: column;
    /* Stack nav links vertically */
    align-items: center;
    gap: 15px;
    /* Smaller gap for mobile */
  }

  /* Ensure Auth component is centered and full-width */
  .auth-container {
    width: 100%;
    max-width: 300px;
    /* Slightly smaller than desktop */
    margin-top: 10px;
    /* Space above login section */
  }
}
</style>